import { render, staticRenderFns } from "./add-to-shopping-list-slide-in.vue?vue&type=template&id=8ca8e0da&"
import script from "./add-to-shopping-list-slide-in.vue?vue&type=script&lang=js&"
export * from "./add-to-shopping-list-slide-in.vue?vue&type=script&lang=js&"
import style0 from "./add-to-shopping-list-slide-in.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports